export function isMessageRead(isRead) {
  if (isRead === true || isRead === 1 || isRead === "1") return true;
  const s = String(isRead ?? "")
    .trim()
    .toLowerCase();
  return s === "true" || s === "yes";
}

/** Sender may edit only their own messages that the recipient has not read yet. */
export function canEditMessage(message, loggedInUserId) {
  if (!message?.message_id) return false;
  const mine =
    String(message?.sender_id ?? "") === String(loggedInUserId ?? "");
  if (!mine) return false;
  return !isMessageRead(message?.is_read);
}
